import React, { useState } from "react";
import "./use-cases.css";
import tabLinkIcon from "../../../images/Agent Trust Images/assets/li-icon.svg";
import tabImage1 from "../../../images/Agent Trust Images/assets/UseCasesSection/Financial Services.svg";
import tabImage2 from "../../../images/Agent Trust Images/assets/UseCasesSection/Healthcare trustscore.svg";
import tabImage3 from "../../../images/Agent Trust Images/assets/UseCasesSection/Retail & E-commerce trustscore.svg";
import tabImage4 from "../../../images/Agent Trust Images/assets/UseCasesSection/Manufacturing & Supply Chain.svg";
import tabImage5 from "../../../images/Agent Trust Images/assets/UseCasesSection/Telecommunications.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";

export default function UseCases() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  const [activeTab, setActiveTab] = useState(0);
  const handleTabSwitch = (index) => {
    setActiveTab(index);
  };
  const tabLinks = [
    {
      category: "Financial Services",
      points: [
        "Secure AI-driven loan approvals with bias-free decision-making",
        "Automate compliance testing to meet financial regulations",
        "Enhance fraud prevention with AI system validation",
      ],
      icon: tabLinkIcon,
      image: tabImage1,
    },
    {
      category: "Healthcare",
      points: [
        "Validate AI in medical diagnosis for precision and fairness",
        "Ensure compliance with HIPAA and GDPR data protection",
        "Assess AI-driven patient recommendation systems",
      ],
      icon: tabLinkIcon,
      image: tabImage2,
    },
    {
      category: "Retail & E-commerce",
      points: [
        "Ensure AI-driven personalization models are fair and unbiased",
        "Validate inventory prediction models for reliable supply chain planning",
        "Detect fraudulent transactions with AI security scoring",
      ],
      icon: tabLinkIcon,
      image: tabImage3,
    },
    {
      category: "Manufacturing & Supply Chain",
      points: [
        "Assess predictive maintenance AI for reliability and bias",
        "Optimize AI-powered quality control for error-free production",
        "Ensure transparency in AI-driven supplier evaluations",
      ],
      icon: tabLinkIcon,
      image: tabImage4,
    },
    {
      category: "Telecommunications",
      points: [
        "Optimize AI network management for reliability and performance",
        "Ensure AI-driven customer support bots provide fair and unbiased assistance",
        "Validate AI algorithms for personalized service recommendations",
      ],
      icon: tabLinkIcon,
      image: tabImage5,
    },
  ];

  return (
    <section
      className={`use-cases-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="four"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>Use Cases</span>
          </div>
          <div className="heading-description">
            <h2>Real-World Applications of Agent Trust </h2>
            <p>
              Ensuring AI Security, Compliance, and Reliability Across
              Industries
            </p>
          </div>
        </div>
        <div className="second-tab-switch-wrapper">
          <div className="tab-links-wrapper">
            {tabLinks.map((item, index) => (
              <div
                className={`${activeTab === index ? "active" : ""}`}
                onClick={() => handleTabSwitch(index)}
                key={index}
              >
                <p>{item.category}</p>
              </div>
            ))}
          </div>
          <div className="second-tab-switch-content-wrapper">
            {tabLinks.map((item, index) => (
              <div
                className={`second-tab-switch-content ${
                  activeTab === index ? "active" : ""
                } `}
                key={index}
              >
                <div className="tab-links">
                  {item.points.map((point, index) => (
                    <div key={index}>
                      <div className="tab-link-heading">
                        <img src={item.icon} alt="tab-icon" />
                        <h3>{point}</h3>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="second-tab-switch-body">
                  <div className="tab-switch-body">
                    <img src={item.image} alt="tab-switch-image" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
